import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';

import { ReactComponent as CloseIcon } from '../../../icons/close.svg';
import IconButton, { IconButtonProps } from '../IconButton';

export interface CloseButtonProps extends Omit<IconButtonProps, 'label'> {
  label?: string;
}

const CloseButton: FC<CloseButtonProps> = (props) => {
  const { t } = useTranslation('Core.CloseButton');
  return (
    <IconButton
      Icon={CloseIcon}
      label={t('closeButton')}
      data-testid="CloseButton"
      {...props}
    />
  );
};

export default CloseButton;
